import React, { FC } from 'react';
import { ChevronRightIcon } from '@components/Icons';


import {
  ContentCardWrapper,
  ContentCardImage,
  ContentCardContent,
  ContentCardTitle,
  ContentCardLink,
} from './ContentCard.elements';

export interface Props {
  title: string;
  link: string;
  enableEliteBadge?: boolean;
  isElite?: boolean;
  imageUrl: string;
}

export const ContentCard: FC<Props> = ({
  title,
  link,
  imageUrl
}) => {
  return (
    <ContentCardWrapper>
      <ContentCardLink href={link}>
        <ContentCardImage
          imageUrl={imageUrl}
        />
        <ContentCardContent>
          <ContentCardTitle>{title}</ContentCardTitle>
          <ChevronRightIcon />
        </ContentCardContent>
      </ContentCardLink>
    </ContentCardWrapper>
  );
};
